import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const PagesList = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch all pages from the API when the component is mounted
    const fetchPages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/pages`
        );
        setPages(response.data); // Set pages to the fetched data
        setLoading(false); // Set loading to false when data is fetched
      } catch (err) {
        setError("Failed to load pages"); // Set error message if the request fails
        setLoading(false); // Set loading to false when error occurs
      }
    };

    fetchPages();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/pages/${id}`);
      setPages(pages.filter((page) => page.id !== id)); // Remove deleted page from the state
      alert("Page deleted successfully");
    } catch (error) {
      console.error(error);
      alert("Failed to delete page");
    }
  };

  const handleEdit = (id) => {
    // Redirect to edit page or open a modal for editing
    alert(`Edit page with ID: ${id}`);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="container">
      <div className="d-flex align-items-center justify-content-start mb-4">
        <h3 className="mb-0 me-3">Pages</h3>
        <Link
          to="/xl-admin/add-page"
          className="btn btn-inchworm btn-sm"
          role="button"
          style={{
            padding: "0.25rem 0.4rem",
            fontSize: "0.8rem",
            lineHeight: "1",
          }}
        >
          Add New
        </Link>
      </div>
      <table className="table table-bordered table-striped">
        <thead className="table-success">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Title</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pages.length > 0 ? (
            pages.map((page, index) => (
              <tr key={page.id}>
                <td>{page.id}</td>
                <td>{page.title}</td>

                <td>{page.status}</td>
                <td>
                  <Link
                    to={`/page/${page.slug}`}
                    className="btn btn-success btn-sm me-2"
                  >
                    View
                  </Link>

                  <button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() => handleEdit(page.id)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(page.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No pages found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PagesList;
